import { api } from ":mods";
import { CONST, model } from "..";

export async function listGet(stage: string | number) {
  return api.getAuth(CONST.ENDPOINTS.admin.list_showcases(stage)).then((res) => res.data as model.ShowcasesList);
}
